import React from 'react';
import { CircularProgress } from '@material-ui/core';

import ProductTile from './ProductTile';
import useStyles from './ShopifyProducts.styles';

const ShopifyProducts = ({
  selectedProduct,
  setSelectedProduct,
  currentPage,
  pageSize,
  products,
  isLoading,
}) => {
  const classes = useStyles();

  if (isLoading) {
    return (
      <div className={classes.loading}>
        <CircularProgress />
      </div>
    );
  }

  if (products.length === 0) {
    return (
      <div className={classes.notFoundContainer}>
        <p>
          No matching products found.
          <br />
          Please update your filters and search criteria.
        </p>
      </div>
    );
  }
  return (
    <div className={classes.root}>
      {products
        .slice((currentPage - 1) * pageSize, currentPage * pageSize)
        .map((product) => (
          <ProductTile
            key={product.id}
            product={product}
            selectedProduct={selectedProduct}
            setSelectedProduct={setSelectedProduct}
          />
        ))}
    </div>
  );
};

export default ShopifyProducts;
